import {Command} from 'substance'
import showConfigurationTestTool from './showConfigurationTestTool'

class ConfigurationTestToolCommand extends Command {

    getCommandState() {
        return true
    }

    execute(params) {
        showConfigurationTestTool(params.api)
    }
}

export default ConfigurationTestToolCommand
